var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('div',[_vm._t("default"),(
      _vm.message.payload &&
        _vm.message.payload.reply_to &&
        _vm.message.payload.reply_to.story
    )?_c('div',{staticClass:"mb-3 d-flex flex-column justify-content-center m-auto"},[_c('p',{staticClass:"text_sm mb-3"},[_vm._v("Hice un comentario en esta historia")]),_c('img',{ref:"storyMedia",staticClass:"story",attrs:{"src":_vm.message.payload.reply_to.story.url},on:{"error":_vm.onImageError}}),_c('hr',{staticClass:"my-2"})]):_vm._e(),_c('pre',{staticClass:"mb-2"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$parseMarkdown(_vm.message.text))}})])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }